import type {Persister} from '@tanstack/react-query-persist-client';

export const QUERY_CLIENT_MAX_AGE = 1000 * 60 * 60 * 24;
export const PERSIST_QUERY_CLIENT_KEY = 'vtx-query-cache';
export const NOOP_PERSISTER: Persister = {
  persistClient: async () => {},
  restoreClient: async () => undefined,
  removeClient: async () => {},
};
